
// const baseurl = "/api";
// const baseurl = "/zdx";

// const baseurl = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_API_URL + '/api' : process.env.VUE_APP_API_URL
// const baseurl = process.env.VUE_APP_API_URL + '/api'
const baseurl = process.env.VUE_APP_API_URL

export default baseurl;

